"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var authentication_1 = require("@dynamynd/authentication");

var components_lib_1 = require("@dynamynd/components-lib");

var content_1 = require("@dynamynd/content");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var user_1 = require("@dynamynd/user");

var react_1 = __importDefault(require("react"));

var components_1 = require("../../components");

var ErrorScreen =
/** @class */
function (_super) {
  __extends(ErrorScreen, _super);

  function ErrorScreen(props) {
    var _this = _super.call(this, props) || this;

    _this.navigate = function (route) {
      return function () {
        _this.props.navigation.navigate(route);
      };
    };

    return _this;
  }

  ErrorScreen.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        WebViewComponent = _a.screenProps.components.WebViewComponent,
        navigation = _a.navigation;
    var shouldRenderUserbox = authentication_1.authService.isAuthenticated();
    return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
      var width = _a.width,
          height = _a.height,
          activeBreakpoint = _a.activeBreakpoint;
      return react_1.default.createElement(components_lib_1.PopupProvider, {
        customStyles: components_lib_1.calculateMenuProviderStyles(activeBreakpoint)
      }, react_1.default.createElement(components_1.ScreenContainer, {
        height: height + "px",
        backgroundcolor: '#F6E8D6'
      }, react_1.default.createElement(content_1.WithAdditionalContent, {
        WebViewComponent: WebViewComponent,
        includeFooter: true
      }, function (_a) {
        var showContent = _a.showContent;
        var small = responsive_1.isSmall(activeBreakpoint);
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_1.ImageBackgroundCustom, {
          style: {
            position: 'absolute',
            width: width + "px",
            height: (height > width ? width : height) + "px",
            top: 'auto',
            left: '0px',
            right: '0px',
            margin: 'auto',
            bottom: 30
          },
          imageStyle: {
            bottom: 0,
            flex: 1
          },
          source: {
            uri: components_lib_1.appConfig.layout.errorPage
          }
        }), react_1.default.createElement(components_1.ErrorContentWrapper, null, react_1.default.createElement(components_1.Header, null, react_1.default.createElement(components_lib_1.LogoMascot, {
          activeBreakpoint: activeBreakpoint,
          color: "purple",
          version: {
            sm: 'image',
            lg: 'image'
          }
        }), shouldRenderUserbox ? react_1.default.createElement(user_1.UserProfileBox, {
          showPrivacy: function showPrivacy() {
            return showContent(content_1.ContentPagesEnum.privacy);
          },
          showTerms: function showTerms() {
            return showContent(content_1.ContentPagesEnum.terms);
          }
        }) : small ? react_1.default.createElement(components_lib_1.ContentItemsPopup, {
          navigation: navigation,
          showPrivacy: function showPrivacy() {
            return showContent(content_1.ContentPagesEnum.privacy);
          },
          showTerms: function showTerms() {
            return showContent(content_1.ContentPagesEnum.terms);
          }
        }) : null), react_1.default.createElement(components_1.ViewWrapper, {
          activeBreakpoint: activeBreakpoint,
          height: height + "px"
        }, react_1.default.createElement(components_1.TextWrapper, null, react_1.default.createElement(components_1.Title, null, "Sorry, We're currently under maintenance."), react_1.default.createElement(components_1.MainText, null, "Please check back later once were done maintenance. Sorry for an inconveniences."), react_1.default.createElement(components_1.RowWrapper, {
          justify: "start"
        }, react_1.default.createElement(components_lib_1.Button, {
          text: "Return To Home",
          uppercase: true,
          type: components_lib_1.ButtonTypeEnum.secondary,
          onPress: _this.navigate(routes_1.RoutesKeysEnum.home)
        }))))));
      })));
    });
  };

  return ErrorScreen;
}(react_1.default.Component);

exports.ErrorScreen = ErrorScreen;
exports.default = ErrorScreen;